import { render } from "./selectCountrie.vue?vue&type=template&id=87076288&scoped=true"
import script from "./selectCountrie.vue?vue&type=script&lang=js"
export * from "./selectCountrie.vue?vue&type=script&lang=js"

import "./selectCountrie.vue?vue&type=style&index=0&id=87076288&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87076288"]])

export default __exports__